module.exports = __webpack_public_path__ + "img/02-04-img-01@2x.3fcf7d71.png";